export default __webpack_public_path__ + "static/media/EXEMPLO 8.6e0707bb.jpg";